<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import moment from 'moment'
import {
  batchComputed,
  authComputed,
  batchListMethod,
  assignmentListMethod,
  userListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Add Assignment',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      title: '',
      description: '',
      date: '',
      assignmentError: null,
      isAssignmentError: false,
      isLoading: false,
      show: false,
      batchlist: [],
      document: [],
      assignedTo: [],
      sizeError: false,
      typeError: false,
      classlist: [],
      collegeId: '',
      collegeClass: [],
      departmentId: [],
      departmentlist: [],
    }
  },
  computed: {
    ...batchComputed,
    ...authComputed,
    ...departmentComputed,
  },
  mounted() {
    this.collegeId = this.profileData.college_id
    this.getDepartments()
    if (this.role === 'teacher') {
      this.collegeClass = this.profileData.collegeClass
      this.departmentId.push(this.profileData.department)
    }
    if (this.role === 'hod') {
      this.departmentId.push(this.profileData.department)
      this.getClasses()
    }
  },
  methods: {
    ...batchListMethod,
    ...assignmentListMethod,
    ...userListMethod,
    ...departmentListMethod,

    // save assignment method
    saveAssignment() {
      this.isAssignmentError = false
      if (!this.sizeError && !this.typeError) {
        let Data = {
          title: this.title,
          description: this.description,
          assigned_to: this.assignedTo,
          document: this.document,
          platform_id: this.currentUser.user.platform_id,
          collegeClass: this.collegeClass,
          department: this.departmentId,
          college_id: this.collegeId,
        }
        if (this.date !== '') {
          let date1 = moment(this.date).add(23, 'h').toDate()
          let date2 = moment(date1).add(59, 'm').toDate()
          Data.deadline = date2
        }
        this.isLoading = true
        this.addAssignmentData({ Data })
          .then((batch) => {
            this.isLoading = false
            this.$router.push({ name: 'assignment.list' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.assignmentError = getError.message
            this.isAssignmentError = true
            window.scrollTo(0, 0)
          })
      }
    },
    handleFileUpload(event) {
      this.document = []
      this.sizeError = false
      this.typeError = false
      let files = event.target.files || event.dataTransfer.files
      let i = 0
      for (i = 0; i < files.length; i++) {
        if (files[i].type === 'application/pdf') {
          if (files[i].size <= 8000000) {
            let obj = {}
            obj['name'] = files[i].name
            const reader = new FileReader()
            reader.readAsDataURL(files[i])
            reader.onload = () => {
              obj['data'] = reader.result
            }
            this.document.push(obj)
          } else {
            this.sizeError = true
          }
        } else {
          this.typeError = true
        }
      }
    },

    getMinDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate() + 1)
      return minDate
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.description.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    getClasses() {
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = []
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isAssignmentError"
              variant="danger"
              v-html="assignmentError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="saveAssignment"
            >
              <b-form-group label="Title*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="title"
                  type="text"
                  placeholder="Enter Assignment Title"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Description*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="description"
                  type="text"
                  placeholder="Enter Assignment Description"
                  @keypress="restrictChars1($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label="Upload PDF File*(Max Size:8 MB)"
                label-for="document"
              >
                <b-form-file
                  id="document"
                  ref="file"
                  type="file"
                  placeholder="Click here to add file"
                  accept=".pdf"
                  multiple
                  @change="handleFileUpload"
                ></b-form-file>
              </b-form-group>
              <p v-if="sizeError" style="color: red"
                >Please upload file less than 8 MB</p
              >
              <p v-if="typeError" style="color: red"
                >Please upload only pdf files</p
              >

              <b-form-group label="Submission Deadline" label-for="date">
                <b-form-datepicker
                  id="example-datepicker"
                  v-model="date"
                  :min="getMinDate()"
                ></b-form-datepicker>
              </b-form-group>
              <b-form-group
                v-if="role !== 'teacher' && role !== 'hod'"
                label="Select Department*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="departmentId"
                  :options="departmentlist"
                  multiple
                  @change="getClasses"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                v-if="role !== 'teacher'"
                label="Select Class*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="collegeClass"
                  :options="classlist"
                  multiple
                ></b-form-select>
              </b-form-group>
              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/assignment-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
</style>
